import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import Link from 'components/styled/link';

const FeedbackWrapper = ({ t, className, feedback, mail }) => (
  <div className={className}>
    <p>
      <Trans
        t={t}
        i18nKey={feedback}
        values={{ mail }}
        components={[
          <Link
            href={`mailto:${mail}`}
            text={mail}
            noTextDecoration
            target="_blank"
          />,
        ]}
      />
    </p>
  </div>
);

FeedbackWrapper.propTypes = {
  className: PropTypes.string.isRequired,
  feedback: PropTypes.string.isRequired,
  mail: PropTypes.string.isRequired,
};

export default FeedbackWrapper;
